import { EVENT_IMPORTED_TYPE_MAP } from './eventImportedTypeMap';

export const EVENT_SOURCES = {
  ...EVENT_IMPORTED_TYPE_MAP,
  IDEALIST: 'Idealist',
};
